<template>
  <div style="margin-bottom: 10px;">
    <template v-if="action.type !== 'like-dislike'">
      <label
        class="template-item"
        v-for="(item, i) in list"
        :key="i"
        :title="`${$t('newAction.stepOne.selectTitle', {
          selectTemplate: `${item.title}`,
        })}`"
        >{{ item.title }}
        <input
          @change="
            changeTemplate(
              $event,
              item.body,
              item._id,
              item.scale,
              item.border,
              item.grade,
            )
          "
          type="radio"
          name="switch-template"
          :value="item.scale"
          :checked="item._id == action.email.template.id"
        />
        <font-awesome-icon
          style="color: #4ce595;"
          :icon="['fas', 'check-circle']"
        />
        <div
          class="remove-template"
          v-if="item._id !== '1' && item._id !== '2' && item._id !== '3'"
          @click="showMsgBox(item._id)"
        >
          <font-awesome-icon
            style="color: red;"
            :icon="['fas', 'times-circle']"
          />
          <div class="bg-icon"></div>
        </div>
        <div class="bg-icon"></div>
      </label>
    </template>
    <template v-else>
      <label
        class="template-item"
        :title="`${$t('newAction.stepOne.selectTitle', {
          selectTemplate: `${list[0].title}`,
        })}`"
        >{{ list[0].title }}
        <input
          @change="
            changeTemplate(
              $event,
              list[0].body,
              list[0]._id,
              list[0].scale,
              list[0].border,
              list[0].grade,
            )
          "
          type="radio"
          name="switch-template"
          :value="list[0].scale"
          :checked="list[0]._id == action.email.template.id"
        />
        <font-awesome-icon
          style="color: #4ce595;"
          :icon="['fas', 'check-circle']"
        />
        <div
          class="remove-template"
          v-if="
            list[0]._id !== '1' && list[0]._id !== '2' && list[0]._id !== '3'
          "
          @click="showMsgBox(list[0]._id)"
        >
          <font-awesome-icon
            style="color: red;"
            :icon="['fas', 'times-circle']"
          />
          <div class="bg-icon"></div>
        </div>
        <div class="bg-icon"></div>
      </label>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EventBus from '../../../../eventBus';

export default {
  name: 'ButtonsTemplates',
  data: () => ({
    msgBox: '',
    userAuth: null,
    customTemplate: false,
  }),
  computed: {
    ...mapState('templates', ['list', 'templateSelected']),
    ...mapState('actions', ['action']),
  },
  methods: {
    showMsgBox(itemId) {
      this.msgBox = '';
      this.$bvModal
        .msgBoxConfirm(this.$t('newAction.stepOne.deleteItem.title'), {
          title: this.$t('newAction.stepOne.deleteItem.description'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('newAction.stepOne.yes'),
          cancelTitle: this.$t('newAction.stepOne.doNotExclude'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.msgBox = value;
          if (this.msgBox) {
            this.delete({
              companyId: this.userAuth.companyId,
              id: itemId,
              token: this.userAuth.token,
            }).then(() => {
              this.setList({
                companyId: this.userAuth.companyId,
                token: this.userAuth.token,
              });
            });
          }
        });
    },
    async changeTemplate(event, html, id, scale, border, grade) {
      await this.setScaleColorsAction(id == 3 ? 'fixedColors' : scale);
      await this.setBorderColorsAction(border);
      await this.setGradeColorsAction(grade);
      await this.setIdTemplate(id);
      if (id === '1' || id === '2' || id === '3') {
        if (this.customTemplate) {
          this.action.email.template.myHTML = html;
          this.customTemplate = false;
        }

        await this.setBodyEmail(this.action.email.template.myHTML);
      } else {
        this.customTemplate = true;
        this.action.email.template.myHTML = html;
        await this.setBodyEmail(html);
      }

      await this.setScaleColors(event.target.value);

      if(scale == 'custom'){
        EventBus.$emit('custom', scale);
      }
    },
    ...mapActions('actions', [
      'setScaleColorsAction',
      'setBorderColorsAction',
      'setGradeColorsAction',
      'setBodyEmail',
      'setIdTemplate',
    ]),
    ...mapActions('templates', ['delete', 'setList', 'setScaleColors']),
  },
  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.template-item {
  display: inline-block;
  background-color: $secondary;
  color: $white;
  margin: 1px;
  padding: 2px 5px;
  position: relative;
  font-size: 0.9em;
  cursor: pointer;
  > svg {
    display: none;
    position: absolute;
    top: -5px;
    right: -5px;
    z-index: 1;
  }
  > .bg-icon {
    background-color: $white;
    width: 14px;
    height: 14px;
    position: absolute;
    top: -5px;
    right: -5px;
    border-radius: 100%;
    z-index: 0;
    display: none;
  }
  .remove-template {
    cursor: pointer;
    > svg {
      // display: none;
      position: absolute;
      top: -5px;
      right: -5px;
      z-index: 1;
    }
    > .bg-icon {
      background-color: $white;
      width: 14px;
      height: 14px;
      position: absolute;
      top: -5px;
      right: -5px;
      border-radius: 100%;
      z-index: 0;
    }
  }
}

input[type='radio'] {
  display: none;
  &:checked {
    ~ svg {
      display: block;
    }
    ~ .bg-icon {
      display: block;
    }

    ~ .remove-template {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/btn-templates/index.vue